import React from "react";
import { useObserver } from "mobx-react";
import { Grid, Paper } from "@material-ui/core";
import { SpinnerOverlay } from "@components";
import locale from "@bonliva-crm/locale";
import { Form, FormxDebugger, Switch } from "@components/formx";
import { Select, Text, TextAutosuggestFormElement } from "@components/formx_item_form";
import { FormElement } from "@components/forms";
import { CustomerType } from "@graphql";
import { ContactPersonFormStore } from "./ContactPersonFormStore";
import { CustomerTreeSelectField } from "@containers";
import { useNavigation } from "@navigation";

export const blockId = "contact_person_form";

type Props = {
  store: ContactPersonFormStore;
};

export function ContactPersonForm(props: Props) {
  const { store } = props;
  const { lockNavigation } = useNavigation();

  lockNavigation(blockId, store.form.dirty);

  return useObserver(() => {
    return (
      <Paper style={{ padding: 16 }}>
        <Form store={store.form} allowUpdates>
          <SpinnerOverlay show={store.form.loading} />
          <Grid container spacing={1} data-test="ContactPersonForm">
            {store.allCustomerGroups.length > 0 && (
              <Select
                multi
                name="CustomerGroups"
                label={locale.CustomerGroups}
                options={store.allCustomerGroups}
              />
            )}

            <Select
              required
              multi
              name="AreasOfExpertise"
              label={locale.AreasOfExpertise}
              options={store.formParams.allowedAreasOfExpertise}
            />

            <Select
              multi
              name="BooksProfessions"
              label={locale.BooksProfessions}
              options={store.allProfessions}
              sortOptions
            />

            <TextAutosuggestFormElement
              required
              TextAutosuggestProps={{
                name: "Title",
                label: locale.Title,
                options: store.allTitles.toLabelValue()
              }}
            />

            <Text required label={locale.Name} name="Name" />
            <Text required label={locale.Email} name="Email" />
            <Text label={locale["Phone number"]} name="Phone" />
            <Text label={locale["CellPhone"]} name="CellPhone" />

            <Select
              multi
              label={locale.Roles}
              name="Roles"
              options={store.allRoles}
              sortOptions
            />

            <FormElement
              required
              field={
                <CustomerTreeSelectField
                  name="Customers"
                  label={locale.Customers}
                  items={store.customer ? store.customer.CustomerTree : []}
                />
              }
            />

            {store.customer?.Type === CustomerType.Hospital && (
              <FormElement
                field={
                  <Switch name="IsInheritable" label={locale.IsContactPersonInheritable} />
                }
              />
            )}
          </Grid>
          <FormxDebugger store={store.form} />
        </Form>
      </Paper>
    );
  });
}
